export default __webpack_public_path__ + "static/media/hubs-children-icon.c7c071fb.svg";